var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chips.length)?_c('span',{staticClass:"lesson-tags"},_vm._l((_vm.chips),function(chip){return _c('span',{key:chip.label,staticClass:"lesson-tag",style:({ '--chip': chip.color })},[_vm._v(_vm._s(chip.label))])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }